import { CardTitleFormatterService, IAppSetting } from '@addins/core/core';
import { LocalizePositionService } from '@addins/core/map';
import { ICallcardListCustomComponent } from '@addins/listcallcards/public_api';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { CallCard } from '@models/imported/SagaSchema/CallCard';
import { CacheService } from '@services/cache/cache.service';
import { AppSettingProviderService } from '@services/settings';
import { filter, Subscription } from 'rxjs';
import { CustomComponentsService } from '../../services/custom-components/custom-components.service';

@Component({
  selector: 'app-callcard-list-item',
  templateUrl: './callcard-list-item.component.html',
  styleUrls: ['./callcard-list-item.component.scss']
})
export class CallCardListItemComponent implements OnInit, OnDestroy {
  @Input()
  callcard: CallCard;
  @Input()
  isMyCallcard: boolean = false;
  @Input()
  cssClass?: string;
  @Input()
  showStatusColor: boolean = false;
  @Input()
  lines: string;

  callcardTitle: string;
  statusColor: string;

  private _locationIconSize: string = 'large';
  get locationIconSize(): string {
    return this._locationIconSize;
  }

  customComponents: ICallcardListCustomComponent[] = [];
  customSlotComponents: ICallcardListCustomComponent[] = [];

  private darkModeSetting: IAppSetting<boolean>;
  private cacheSub: Subscription = null;

  constructor(
    private titleFormatter: CardTitleFormatterService,
    private localizePositionService: LocalizePositionService,
    private customComponentsService: CustomComponentsService,
    private appSettingsProvider: AppSettingProviderService,
    private cacheService: CacheService
  ) {}

  ngOnInit() {
    this.setCallcardTitle();

    this.customComponents = this.customComponentsService.customComponents.filter(component => !component.slot);
    this.customSlotComponents = this.customComponentsService.customComponents.filter(component => component.slot);

    this.appSettingsProvider.getLargeFont().subscribe(appSetting => {
      this._locationIconSize = appSetting.current ? 'xlarge' : 'large';
    });

    if (this.showStatusColor) {
      this.appSettingsProvider.getDarkModeEnabled().subscribe(appSetting => {
        this.darkModeSetting = appSetting;
        this.refreshStatusColor();
      });

      this.cacheSub = this.cacheService
        .listenForChange(CallCard)
        .pipe(filter(cacheEvent => (cacheEvent.object as CallCard).ObjGuid === this.callcard.ObjGuid))
        .subscribe(() => {
          this.setCallcardTitle();
          this.refreshStatusColor();
        });
    }
  }
  private setCallcardTitle() {
    this.callcardTitle = this.titleFormatter.format(this.callcard);
  }

  private refreshStatusColor() {
    const callcardStatus = this.callcard.status;
    const oColor = callcardStatus.oColor ? callcardStatus.oColor : callcardStatus.color;
    this.statusColor = (this.darkModeSetting?.current ? oColor : callcardStatus.color).toRgbString();
  }

  ngOnDestroy() {
    this.cacheSub?.unsubscribe();
  }

  onLocalize($event: MouseEvent | TouchEvent) {
    $event.stopPropagation();
    $event.preventDefault();

    this.localizePositionService.localize({
      coordinates: [this.callcard.location.coordinate],
      target: null
    });
  }
}
